const DatabaseEnum = {
  Main:"Main",
  Merchant:"Merchant",
  Node:"Node",
  Trade:"Trade",
  Klines:"Klines",
}

module.exports = {DatabaseEnum,};